var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation, useQueryClient } from 'react-query';
import { useAxios } from 'shared/hooks';
import { queryCache } from '../../../../reactQuery';
export var useDeleteNoteMutation = function (_a) {
    var appointmentId = _a.appointmentId, onError = _a.onError, onSuccess = _a.onSuccess;
    var queryClient = useQueryClient();
    var axios = useAxios();
    return useMutation(function (_a) {
        var id = _a.id, payload = __rest(_a, ["id"]);
        return axios.request({
            method: 'DELETE',
            data: payload,
            url: "/api/v1/notes/".concat(id),
        });
    }, {
        onError: onError,
        onSuccess: function (_, variables) {
            queryCache.removeQueries(['note', variables.id]);
            queryClient.invalidateQueries(['note', variables.id]);
            queryClient.invalidateQueries('notes');
            queryClient.invalidateQueries('past_interactions');
            queryClient.invalidateQueries('todo_notes');
            queryClient.invalidateQueries('signed_notes');
            queryClient.invalidateQueries('member-planned-followup');
            if (appointmentId) {
                // invalidate note setup
                queryClient.removeQueries(['note-setup', appointmentId]);
            }
            onSuccess && onSuccess();
        },
    });
};
